import { Injectable } from "@angular/core";
import { RegionEnum } from "@edp-enums/region.enum";
import { environment } from "@edp-environments/environment";
import { regionComponentsHidden } from "@edp-utils/region-components-hidden.utils";
import { getRegionByTLD } from "@edp-utils/region.utils";
import { CookieService } from "ngx-cookie-service";
import { Request } from "@edp-utils/request.utils";

const KEY_COOKIE_CURRENT_REGION = "CurrentRegion";

@Injectable({
    providedIn: "root",
})
export class RegionService {
    private region: RegionEnum;

    constructor(private cookieService: CookieService) {
        this.setRegion();
    }

    public setCookieCurrentRegion(): any {
        if (!!environment.production) {
            return;
        }
        const now = new Date();
        now.setTime(now.getTime() + 1 * 3600 * 1000 * 24);
        this.cookieService.set(KEY_COOKIE_CURRENT_REGION, this.region, now);
    }

    public getFirebaseSettings(): any {
        const region = this.getRegion();
        return environment.firebase[region];
    }

    public getRegion(): RegionEnum {
        return this.region || RegionEnum.PT;
    }

    private checkLocalhostRegion(): RegionEnum {
        if (Request.getParameter("region")) {
            const regionQueryParam = Request.getParameter("region");
            const region: RegionEnum = Object.keys(RegionEnum).includes(regionQueryParam) ? RegionEnum[regionQueryParam] : getRegionByTLD();
            return region;
        }
        if (!!this.cookieService.get(KEY_COOKIE_CURRENT_REGION)) {
            const cookieCurrentRegion = this.cookieService.get(KEY_COOKIE_CURRENT_REGION);
            const region: RegionEnum = Object.keys(RegionEnum).includes(cookieCurrentRegion)
                ? RegionEnum[cookieCurrentRegion]
                : getRegionByTLD();
            return region;
        }
    }

    private setRegion(): void {
        if (!environment.production) {
            const parmRegion = this.checkLocalhostRegion();
            if (parmRegion) {
                this.region = parmRegion;
                return;
            }
        }
        this.region = getRegionByTLD();
    }

    public getHiddenElements(key: string): boolean {
        if (regionComponentsHidden[key]) {
            return !regionComponentsHidden[key].includes(this.region);
        }
        return true;
    }
}
